<template>
  <div v-if="articleLabels && articleLabels.length">
    <div>
      <div
        class="content-item flex"
        v-for="(item, index) in articleLabels"
        :key="index"
      >
        <el-tooltip effect="dark" :content="item.name" placement="top">
          <p style="max-width: 107px; height: 40px">
            <span
              :style="{ marginLeft: item.name.length > 6 ? '10px' : '0' }"
              class="eye-gray"
              v-if="item.invisibleStatus == 3 || item.invisibleStatus == 4"
            ></span
            >{{ item.name }}
          </p>
        </el-tooltip>
        <el-cascader
          class="select-role"
          :options="item.contentLabels"
          v-model="labelValue[index]"
          :props="{
            multiple: true,
            value: 'id',
            label: 'name',
            children: 'contentLabels',
            checkStrictly: true,
          }"
        ></el-cascader>
      </div>
    </div>
  </div>
</template>

<script>
import { queryLabel } from "../../api/questionsLibrary";

var app_type = process.env.VUE_APP_TYPE;

export default {
  name: "QuestionCascader",
  props: ["id", "functionIds"],
  data() {
    return {
      articleLabels: [],
      labelValue: [],
      app_type,
    };
  },
  created() {
    // if (this.id) {
    this.getTagGroup();
    // }
    console.log("hahahahah", this.id);
  },
  mounted() {
    console.log("组件加载了QuestionCascader------->");
    const $el = document.querySelectorAll(
      ".el-cascader-panel .el-cascader-node[aria-owns]"
    );
    Array.from($el).map((item) => item.removeAttribute("aria-owns"));
  },
  methods: {
    // 获取选中标签
    getFormLabelData(form) {
      let newList = []; // 原始数据
      let numList = []; // 选择的id
      // 整合原始数据
      this.articleLabels.map((item) => {
        // 一级数据
        item.contentLabels.map((oneItem) => {
          if (oneItem.contentLabels) {
            // 二级数据
            if (oneItem.contentLabels) {
              oneItem.contentLabels.map((twoItme) => {
                newList.push(twoItme);
                // 三级数据
                if (twoItme.contentLabels) {
                  twoItme.contentLabels.map((three) => {
                    newList.push(three);
                  });
                }
              });
            }
          }
          newList.push(oneItem);
        });
      });
      // 选择的id
      this.labelValue.map((item) => {
        item.map((itemId) => {
          if (itemId.length == 2) {
            numList.push(itemId[1]);
          } else if (itemId.length == 3) {
            numList.push(itemId[2]);
          } else {
            numList.push(itemId[0]);
          }
        });
      });
      // 新增和回显数据
      form.extensionContentLabels = [];
      newList.map((item) => {
        numList.map((idItme) => {
          if (item.id == idItme) {
            form.extensionContentLabels.push(item);
          }
        });
      });
    },
    // 获取标签组
    async getTagGroup(id) {
      // console.log('开始请求标签组')
      await queryLabel({
        contentId: this.id || id,
        tenantId: this.$commonJs.getTenantId(),
        labelType: 1,
        labelGroupId: this.$commonJs.getTenantId() == 287 ? "782" : "10014949",
      }).then((res) => {
        console.log("获取的标签组");
        console.log(res);
        this.articleLabels = res.data;
        this.articleLabels.forEach((oneLevel) => {
          oneLevel.valueId = [];
          oneLevel.contentLabels.forEach((twoLevel, index) => {
            if (twoLevel.contentLabels.length > 0) {
              twoLevel.disabled = true;
              twoLevel.contentLabels.forEach((item) => {
                item.contentLabels.forEach((three) => {
                  if (three.contentLabels.length < 1) {
                    three.contentLabels = undefined;
                  }
                });
                if (item.contentLabels.length > 0) {
                  item.disabled = true;
                } else {
                  item.contentLabels = undefined;
                }
              });
            } else {
              twoLevel.disabled = false;
              twoLevel.contentLabels = undefined;
            }
          });
        });
        this.articleLabels.forEach((item) => {
          item.valueId = [];
          // 第一级
          item.contentLabels.map((dataOne) => {
            // console.log('dataOne:')
            // console.log(dataOne.isChecked)
            if (dataOne.isChecked) {
              item.valueId.push([dataOne.id]);
            }
            // 第二级
            if (dataOne.contentLabels) {
              dataOne.contentLabels.map((dataTwo) => {
                // console.log('dataOne:')
                // console.log(dataTwo.isChecked)
                if (dataTwo.isChecked) {
                  item.valueId.push([dataOne.id, dataTwo.id]);
                }
                // 第三级
                if (dataTwo.contentLabels) {
                  dataTwo.contentLabels.map((three) => {
                    // console.log('three:')
                    // console.log(three.isChecked)
                    if (three.isChecked) {
                      item.valueId.push([dataOne.id, dataTwo.id, three.id]);
                    }
                  });
                }
              });
            }
          });
          this.labelValue.push(item.valueId);
        });
        console.log(
          "this.labelValue------>",
          this.labelValue,
          this.articleLabels
        );
        // console.log(this.labelValue)
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.eye-gray {
  content: "";
  display: inline-block;
  background: url("~@/assets/eye-gray.png") no-repeat 0 0;
  background-size: 18px 18px;
  width: 18px;
  height: 18px;
  margin-left: -20px;
  margin-top: -15px;
}

// 点击文字选中
.el-cascader-panel .el-checkbox {
  width: 100%;
  height: 100%;
  z-index: 10;
  position: absolute;
}

.el-cascader-node__label {
  margin-left: 10px;
}

:deep(.el-input) {
  width: 600px !important;
}

:deep(.el-cascader) {
  width: 100%;
}

// 文字过多，省略样式
.content-item p {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>
